"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransactionFromInstructions = void 0;
const web3_js_1 = require("@solana/web3.js");
const createTransactionFromInstructions = (instructions) => {
    const transaction = new web3_js_1.Transaction();
    transaction.add(...instructions);
    return transaction;
};
exports.createTransactionFromInstructions = createTransactionFromInstructions;
//# sourceMappingURL=helpers.js.map